import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2'
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

export default new Vuetify({
    rtl: true,
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        light: true,
        themes: {
            light: {
                background: '#fafafa',
                default: '#fff',
                gray: '#7F8C8D',
                primary: '#fbb545',
                secondary: '#34495E',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#41a8bb',
                success: '#1adc68',
                warning: '#FB8C00',
            },
        }
    },
});